module.exports = __webpack_public_path__ + "img/ass21.b9181323.png";